import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatRadioButton, MatRadioChange, MatRadioGroup } from '@angular/material/radio';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { DarkModeDirective } from 'directives/dark-mode.directive';

export interface SelectCardOption<T> {
  label: string;
  icon: string;
  disabled?: boolean;
  value: T;
}

@Component({
  selector: 'core-ui-select-card',
  imports: [MatCard, MatRadioGroup, MatRadioButton, NgClass, MatIcon, DarkModeDirective],
  templateUrl: './select-card.component.html',
  styleUrl: './select-card.component.scss'
})
export class SelectCardComponent<T> {
  @Input() public options: SelectCardOption<T>[];
  @Input() public value: T;
  @Output() public valueChange = new EventEmitter<T>();

  public radioChange(event: MatRadioChange): void {
    this.value = event.value;
    this.valueChange.emit(this.value);
  }
}
